import { createContext, useReducer, ReactNode } from 'react';

interface SidebarContextType {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
}

type SidebarAction = { type: 'SET_EXPANDED'; payload: boolean };

const sidebarReducer = (state: boolean, action: SidebarAction): boolean => {
  switch (action.type) {
    case 'SET_EXPANDED':
      return action.payload;
    default:
      return state;
  }
};

export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
  const [isExpanded, dispatch] = useReducer(sidebarReducer, false);

  const setIsExpanded = (expanded: boolean) => {
    dispatch({ type: 'SET_EXPANDED', payload: expanded });
  };

  return (
    <SidebarContext.Provider value={{ isExpanded, setIsExpanded }}>
      {children}
    </SidebarContext.Provider>
  );
};
